import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from '@mui/material';

/**
 * 알림 그만 받기 — 사유 입력.
 *
 * 사유를 남기는 이유: 알림을 끄는 것과 일이 끝난 것은 다르다.
 * 누가·왜 껐는지가 없으면 나중에 그 건을 어떻게 할지 판단할 근거가 사라진다.
 * 그래서 서버에서도 사유를 필수로 받는다.
 */
const IgnoreReasonDialog = ({ open, notiTxt, bulkCount, onClose, onConfirm }) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  const trimmed = reason.trim();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {bulkCount ? `${bulkCount}건 그만 받기` : '이 건은 그만 받기'}
      </DialogTitle>
      <DialogContent>
        {bulkCount > 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            지금 목록에 있는 반복 알림 {bulkCount}건을 모두 끕니다.
          </Typography>
        )}
        {notiTxt && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {notiTxt}
          </Typography>
        )}
        <Typography variant="body2" sx={{ mb: 1.5 }}>
          더 이상 알리지 않습니다. 어떤 이유인지 남겨주세요.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={2}
          size="small"
          placeholder="예: 고객 요청으로 출고 보류"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1.5 }}>
          알림만 끄는 것이고 출고 건이 종료되는 것은 아닙니다. 목록에는 그대로 남습니다.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>취소</Button>
        <Button variant="contained" disabled={!trimmed} onClick={() => onConfirm(trimmed)}>
          그만 받기
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IgnoreReasonDialog;
